// Routes shared by the login and team pages

const SHARED_ROUTES = Object.freeze({
  /** Our callback URL that is allow-listed on the auth server */
  CALLBACK: '/login/callback',
});

export default SHARED_ROUTES;
